import { AutoMap } from "@automapper/classes";

export class InterventionEntity {

    Id?: number;
    @AutoMap()
    Code!: string;
    @AutoMap()
    NomChantier!: string
    @AutoMap()
    Status!: number;
    @AutoMap()
    PlannedDate!: string;
    @AutoMap()
    IsLastMinute: boolean = false;
    @AutoMap()
    Comment?: string;
    @AutoMap()
    AdresseChantier: string = '';
    SamplerId!: number;
    ContactId!: number;

    BiocollecteurId?: number;
    ApplicateurContactId?: number;
    CompteurId?: number;
    MultimetreId?: number;

    ZoneIds?: number[];
    GenerateurIds?: number[];
    EndoscopeIds?: number[];
}